/* ONYX — Commercial Pin Loaded
   Progressive enhancement only. Every control works as a normal link/paginated
   page load if this file never executes. Initialises per-section, on this page only. */
(function () {
  'use strict';

  var SEL = '[data-onyx-collection]';

  /* Mobile scroll affordance for the category rail.
     The controls are created with JavaScript because they are only useful when
     smooth scrolling is available. They sit outside the scroller so replacing
     the navigation contents after filtering does not destroy them. */
  function initRail(root) {
    var scroller = root.querySelector('[data-onyx-nav]');
    if (!scroller || scroller.dataset.onyxRail === '1') return;

    scroller.dataset.onyxRail = '1';

    var rail = document.createElement('div');
    rail.className = 'onyx-pin-nav__rail';
    scroller.parentNode.insertBefore(rail, scroller);
    rail.appendChild(scroller);

    function createChevron(direction) {
      var button = document.createElement('button');
      var isNext = direction === 1;

      button.type = 'button';
      button.className =
        'onyx-pin-nav__edge onyx-pin-nav__edge--' +
        (isNext ? 'next' : 'prev');

      button.setAttribute(
        'aria-label',
        isNext ? 'Show more categories' : 'Show previous categories'
      );

      button.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" ' +
        'stroke="currentColor" stroke-width="1.5" stroke-linecap="square" ' +
        'aria-hidden="true" focusable="false">' +
        '<path d="' +
        (isNext ? 'M9 6l6 6-6 6' : 'M15 6l-6 6 6 6') +
        '"></path></svg>';

      button.addEventListener('click', function () {
        var reduceMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        /* Temporarily disable scroll snapping so Chrome does not snap the
           navigation back to its original position. */
        var restored = false;

        var restoreSnap = function () {
          if (restored) return;

          restored = true;
          scroller.style.scrollSnapType = '';
          scroller.removeEventListener('scrollend', restoreSnap);
        };

        scroller.style.scrollSnapType = 'none';
        scroller.addEventListener('scrollend', restoreSnap);
        window.setTimeout(restoreSnap, 700);

        scroller.scrollBy({
          left: direction * Math.round(scroller.clientWidth * 0.7),
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      });

      rail.appendChild(button);
      return button;
    }

    var previousButton = createChevron(-1);
    var nextButton = createChevron(1);

    function setActive(button, active) {
      if (active) {
        button.removeAttribute('data-onyx-inactive');
        button.removeAttribute('aria-hidden');
        button.removeAttribute('tabindex');
      } else {
        button.setAttribute('data-onyx-inactive', '');
        button.setAttribute('aria-hidden', 'true');
        button.setAttribute('tabindex', '-1');
      }
    }

    function update() {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;

      if (!isMobile) {
        setActive(previousButton, false);
        setActive(nextButton, false);
        return;
      }

      var maximumScroll = scroller.scrollWidth - scroller.clientWidth;

      setActive(
        previousButton,
        maximumScroll > 2 && scroller.scrollLeft > 2
      );

      setActive(
        nextButton,
        maximumScroll > 2 &&
          scroller.scrollLeft < maximumScroll - 2
      );
    }

    scroller.addEventListener('scroll', update, {
      passive: true
    });

    window.addEventListener('resize', update);

    /* Recalculate the arrows when filtering replaces the navigation tabs. */
    if (typeof MutationObserver === 'function') {
      new MutationObserver(update).observe(scroller, {
        childList: true,
        subtree: true
      });
    }

    if (typeof ResizeObserver === 'function') {
      var resizeObserver = new ResizeObserver(update);

      resizeObserver.observe(scroller);

      var list = scroller.querySelector('.onyx-pin-nav__list');

      if (list) {
        resizeObserver.observe(list);
      }
    }

    /* Recalculate after the ONYX fonts have loaded. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready
        .then(update)
        .catch(function () {});
    }

    update();
  }

  function init(root) {
    if (!root || root.dataset.onyxReady === '1') return;

    root.dataset.onyxReady = '1';

    initRail(root);

    var sectionId = root.dataset.sectionId;
    var grid = root.querySelector('[data-onyx-grid]');

    if (!grid || !sectionId) return;

    var controller = null;

    function swap(url, push, append) {
      if (controller) {
        controller.abort();
      }

      controller = new AbortController();
      grid.setAttribute('aria-busy', 'true');

      var fetchUrl =
        url +
        (url.indexOf('?') === -1 ? '?' : '&') +
        'section_id=' +
        encodeURIComponent(sectionId);

      fetch(fetchUrl, {
        signal: controller.signal,
        headers: {
          'X-Requested-With': 'fetch'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              'Section fetch failed: ' + response.status
            );
          }

          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(
            html,
            'text/html'
          );

          var nextGrid = doc.querySelector(
            '[data-onyx-grid]'
          );

          if (!nextGrid) {
            throw new Error('No grid in response');
          }

          if (append) {
            var items = grid.querySelector(
              '[data-onyx-items]'
            );

            var nextItems = nextGrid.querySelector(
              '[data-onyx-items]'
            );

            if (items && nextItems) {
              while (nextItems.firstElementChild) {
                items.appendChild(
                  nextItems.firstElementChild
                );
              }
            }

            var more = grid.querySelector(
              '[data-onyx-more]'
            );

            var nextMore = nextGrid.querySelector(
              '[data-onyx-more]'
            );

            if (more) {
              if (nextMore) {
                more.replaceWith(nextMore);
              } else {
                more.remove();
              }
            }
          } else {
            grid.innerHTML = nextGrid.innerHTML;
          }

          var nextNav = doc.querySelector(
            '[data-onyx-nav]'
          );

          var nav = root.querySelector(
            '[data-onyx-nav]'
          );

          if (nav && nextNav) {
            nav.innerHTML = nextNav.innerHTML;
          }

          var count = root.querySelector(
            '[data-onyx-count]'
          );

          var nextCount = doc.querySelector(
            '[data-onyx-count]'
          );

          if (count && nextCount) {
            count.textContent = nextCount.textContent;
          }

          if (push) {
            history.pushState(
              { onyx: true },
              '',
              url
            );
          }

          grid.removeAttribute('aria-busy');

          if (!append) {
            var focusTarget = root.querySelector(
              '[data-onyx-nav] [aria-current="true"]'
            );

            if (focusTarget) {
              focusTarget.focus({
                preventScroll: true
              });
            }
          }
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;

          grid.removeAttribute('aria-busy');
          window.location.href = url;
        });
    }

    root.addEventListener('click', function (event) {
      var filter = event.target.closest(
        '[data-onyx-filter]'
      );

      if (filter && root.contains(filter)) {
        event.preventDefault();

        swap(
          filter.getAttribute('href'),
          true,
          false
        );

        return;
      }

      var more = event.target.closest(
        '[data-onyx-load-more]'
      );

      if (more && root.contains(more)) {
        event.preventDefault();

        more.textContent =
          more.dataset.loadingLabel || 'Loading';

        swap(
          more.getAttribute('href'),
          false,
          true
        );
      }
    });

    window.addEventListener('popstate', function () {
      swap(
        window.location.href,
        false,
        false
      );
    });
  }

  function boot() {
    document.querySelectorAll(SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot
    );
  } else {
    boot();
  }

  window.addEventListener('load', boot);

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      var root =
        event.target.matches &&
        event.target.matches(SEL)
          ? event.target
          : event.target.querySelector(SEL);

      if (root) {
        init(root);
      }
    }
  );
})();